'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: ', ';\n  border-radius: 100%;\n  display: inline-block;\n  margin-right: ', ';\n\n  && {\n    /* override competing rule when used as a dropdown option avatar */\n    height: ', ';\n    width: ', ';\n  }\n'], ['\n  background-color: ', ';\n  border: ', ';\n  border-radius: 100%;\n  display: inline-block;\n  margin-right: ', ';\n\n  && {\n    /* override competing rule when used as a dropdown option avatar */\n    height: ', ';\n    width: ', ';\n  }\n']);

var _react = require('react');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UITag = require('./UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _Style = require('../core/Style');

var _colors = require('HubStyleTokens/colors');

var Colors = _interopRequireWildcard(_colors);

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var statusColors = {
  disabled: Colors.BATTLESHIP,
  success: Colors.OZ,
  warning: Colors.MARIGOLD,
  danger: Colors.CANDY_APPLE,
  info: Colors.CALYPSO
};

var getDotColor = function getDotColor(color, use) {
  if (color != null) return color;
  var computedUse = _UITag2.default.STATUS_ALIAS_MAP[use] || use;
  return statusColors[computedUse] || Colors[computedUse.toUpperCase().replace('-', '_')] || Colors.BATTLESHIP;
};

var UIStatusDot = _styledComponents2.default.span.withConfig({
  displayName: 'UIStatusDot'
})(_templateObject, function (_ref) {
  var color = _ref.color,
      hollow = _ref.hollow,
      use = _ref.use;
  return !hollow && getDotColor(color, use);
}, function (_ref2) {
  var color = _ref2.color,
      hollow = _ref2.hollow,
      use = _ref2.use;
  return hollow && '2px solid ' + getDotColor(color, use);
}, (0, _Style.remCalc)(_sizes.TAG_ICON_SPACING_X), (0, _Style.remCalc)(10), (0, _Style.remCalc)(10));

UIStatusDot.propTypes = {
  color: _react.PropTypes.string,
  hollow: _react.PropTypes.bool.isRequired,
  use: _UITag2.default.propTypes.use
};

UIStatusDot.defaultProps = {
  hollow: false,
  use: 'info'
};

UIStatusDot.getDotColor = getDotColor; // expose for tests

exports.default = UIStatusDot;
module.exports = exports['default'];